import { Button } from '@/components/ui/button'

interface LoadMoreBarProps {
  /** Number of rows loaded so far (across all fetched pages). */
  loaded: number
  /** Total matching rows, when known. Omit/0 to show just the loaded count. */
  total?: number
  /** Whether another page can be fetched. When false the bar renders nothing. */
  hasMore: boolean
  /** True while the next page is in flight. */
  isLoading: boolean
  onLoadMore: () => void
}

/**
 * "Showing X of Y — Load more" control for offset-paginated lists.
 *
 * Shared by the events and invoices list pages; the leads page keeps its own
 * inline copy. Renders nothing once every page has been loaded.
 */
export function LoadMoreBar({ loaded, total, hasMore, isLoading, onLoadMore }: LoadMoreBarProps) {
  if (!hasMore) return null

  return (
    <div className="flex flex-shrink-0 items-center justify-center gap-3 py-1">
      <span className="text-sm text-muted-foreground">
        {total && total > 0 ? `Showing ${loaded} of ${total}` : `Showing ${loaded}`}
      </span>
      <Button variant="outline" size="sm" onClick={onLoadMore} disabled={isLoading}>
        {isLoading ? 'Loading…' : 'Load more'}
      </Button>
    </div>
  )
}
